var React = require('react');

function LoginInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3 8.2C9.91 8.59 9.91 9.21 10.3 9.6L12.2 11.5H3C2.45 11.5 2 11.95 2 12.5C2 13.05 2.45 13.5 3 13.5H12.2L10.3 15.4C9.91 15.79 9.91 16.41 10.3 16.8C10.69 17.19 11.31 17.19 11.7 16.8L15.29 13.21C15.68 12.82 15.68 12.19 15.29 11.8L11.7 8.2C11.31 7.81 10.69 7.81 10.3 8.2ZM20 19.5H13C12.45 19.5 12 19.95 12 20.5C12 21.05 12.45 21.5 13 21.5H20C21.1 21.5 22 20.6 22 19.5V5.5C22 4.4 21.1 3.5 20 3.5H13C12.45 3.5 12 3.95 12 4.5C12 5.05 12.45 5.5 13 5.5H20V19.5Z","fill":"currentColor"}));
}

LoginInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = LoginInline;

LoginInline.default = LoginInline;
